export default {
  new: "deep-orange lighten-1",
  draft: "indigo lighten-1",
  pending: "orange lighten-1",
  review: "teal lighten-1",
  open: "amber lighten-1",
  accepted: "primary",
  declined: "red lighten-1",
  rejected: "red accent-4",
  posted: "cyan lighten-1",
  approved: "primary",
  released: "primary",
  UnitBooking: "red",
};
